module.exports = __webpack_public_path__ + "static/img/13.fb78916.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/4/zh/13.png
// module id = wOsv
// module chunks = 0